import { useState } from 'react';
import { useApp } from '../../context/AppContext.jsx';

const STRUCT_OPTIONS = [
  { value: 'LILLYBELLE_BURKINA', label: 'Lillybelle Burkina' },
  { value: 'LILLYBELLE', label: 'Lillybelle France' },
  { value: 'LILLYBELLE_H', label: 'Lillybelle Group' },
  { value: 'LILLYBELLE_SENEGAL', label: 'Lillybelle Sénégal' },
  { value: 'LILLYBELLE_TOGO', label: 'Lillybelle Togo' }
];

export function AssignModal() {
  const { unmatchedModal, setUnmatchedModal, saveAssignments } = useApp();
  const [assignments, setAssignments] = useState({});

  if (!unmatchedModal?.length) return null;

  const handleSave = () => {
    const payload = unmatchedModal.map((name) => ({
      name,
      struct: assignments[name] || ''
    }));
    saveAssignments(payload);
    setAssignments({});
  };

  return (
    <div
      id="modalOverlay"
      style={{
        display: 'flex',
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 1000,
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onClick={(e) => e.target.id === 'modalOverlay' && setUnmatchedModal(null)}
    >
      <div
        style={{
          background: '#FFF',
          borderRadius: 14,
          padding: '28px 32px',
          maxWidth: 520,
          width: '90%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>
          ⚠️ Collaborateurs non reconnus
        </div>
        <div style={{ fontSize: 13, color: '#6B6860', marginBottom: 20, lineHeight: 1.5 }}>
          Ces personnes n&apos;ont pas pu être rattachées à une structure automatiquement.
          <br />
          Assignez-leur une structure — ce choix sera mémorisé pour les prochains imports.
        </div>
        <div id="modalList" style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: 340, overflowY: 'auto', marginBottom: 20 }}>
          {unmatchedModal.map((name) => (
            <div key={name} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #F0EDE8' }}>
              <span style={{ flex: 1, fontSize: 13, fontWeight: 500 }}>{name}</span>
              <select
                value={assignments[name] || ''}
                onChange={(e) => setAssignments((prev) => ({ ...prev, [name]: e.target.value }))}
                style={{ padding: '5px 8px', border: '1px solid #E2DED6', borderRadius: 6, fontSize: 12, fontFamily: 'inherit' }}
              >
                <option value="">-- Structure --</option>
                {STRUCT_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button type="button" onClick={() => setUnmatchedModal(null)} style={{ padding: '8px 18px', border: '1px solid #E2DED6', borderRadius: 7, fontSize: 13, background: 'transparent', cursor: 'pointer', fontFamily: 'inherit' }}>
            Ignorer
          </button>
          <button type="button" onClick={handleSave} style={{ padding: '8px 18px', background: '#1A1916', color: '#FFF', border: 'none', borderRadius: 7, fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit' }}>
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}


